import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPayment.List.IRequest;
type Response = Api.Finance.ClaimJobPayment.List.IResponse;
type Headers = Api.Finance.ClaimJobPayment.List.IHeaders;
const url = '/api/Finance/ClaimJobPayment';
export default async function claimJobPaymentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
